import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-vrjmof.svg'
import _imports_1 from '@/assets/images/prologue/logo-date_pre.svg'
import _imports_2 from '@/assets/images/banner_livestream.png'
import _imports_3 from '@/assets/images/prologue/image-schedule.jpg'
import _imports_4 from '@/assets/images/floorMap.png'
import _imports_5 from '@/assets/images/prologue/title-boshu.svg'
import _imports_6 from '@/assets/images/prologue/program-apply.jpg'
import _imports_7 from '@/assets/images/prologue/title-list.svg'
import _imports_8 from '@/assets/images/prologue/title-notice.svg'
import _imports_9 from '@/assets/images/logo-vrchat_ex.png'
import _imports_10 from '@/assets/images/logo-neos.svg'
import _imports_11 from '@/assets/images/user-circle-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-17198ee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "VR JMoF",
    class: "main"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Prologue Event date: 2022.10.22",
    class: "sub"
  })
], -1))
const _hoisted_2 = { class: "main-section" }
const _hoisted_3 = { class: "main-catch" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 2年ぶりにVR JMoFのプレイベントが開催決定！"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" VRケモノコンベンション“VR JMoF 2023”は、2023年1月に愛知県・豊橋で開催されるリアルケモノコンベンション“JMoF 2023”との同時開催を予定しています。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" それに先駆け、お試し企画盛りだくさんのプレイベント“VR JMoF Prologue”を開催します！ ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " VRChatだけにとどまらず、NeosVRやリアルJMoFも巻き込んだボリューム満点の企画を用意しました。 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-link-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "banner-link" }, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.twitch.tv/vr_jmof/"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        alt: "公式動画配信 / Official Livestream",
        width: "300"
      })
    ])
  ])
], -1))
const _hoisted_7 = { class: "dialog-button" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M152 64H296V24C296 10.75 306.7 0 320 0C333.3 0 344 10.75 344 24V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H104V24C104 10.75 114.7 0 128 0C141.3 0 152 10.75 152 24V64zM48 448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V192H48V448z" })
], -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" タイムテーブル ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M565.6 36.24C572.1 40.72 576 48.11 576 56V392C576 401.1 569.8 410.9 560.5 414.4L392.5 478.4C387.4 480.4 381.7 480.5 376.4 478.8L192.5 417.5L32.54 478.4C25.17 481.2 16.88 480.2 10.38 475.8C3.882 471.3 0 463.9 0 456V120C0 110 6.15 101.1 15.46 97.57L183.5 33.57C188.6 31.6 194.3 31.48 199.6 33.23L383.5 94.52L543.5 33.57C550.8 30.76 559.1 31.76 565.6 36.24H565.6zM48 421.2L168 375.5V90.83L48 136.5V421.2zM360 137.3L216 89.3V374.7L360 422.7V137.3zM408 421.2L528 375.5V90.83L408 136.5V421.2z" })
], -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 会場マップ ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dialog-image",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-map" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "dialog-image",
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "main-heading",
  id: "avatar_poster"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "企画募集"
  })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "boshu-box",
  id: "avatar_poster"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "",
    class: "image"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "アバター＆ポスター募集"),
    /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
      /*#__PURE__*/_createTextVNode(" VR JMoFワールド内に展示する、皆さんが制作したアバターやポスターを大募集！"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 世界各地からケモノ好きが集まるこの場所を、あなたの制作したケモノアバターや、ケモノイベント／VR内の集会などを紹介するポスターで彩って、もっと盛り上げてみませんか？"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" なんと今回はNeosVR会場にもアバター＆ポスターを展示可能！"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 皆さんのご応募をお待ちしています！ ")
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "note" }, [
      /*#__PURE__*/_createElementVNode("li", { class: "item" }, " 応募規約やフォーマットについては応募フォームに記載しています。 "),
      /*#__PURE__*/_createElementVNode("li", { class: "item" }, " 展示継続を希望されない場合、展示期間は2022年10月末ごろまでを予定しています。 ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "button" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "button-apply -disabled",
        target: "_blank",
        href: "https://forms.gle/mpuWk7KKqT236PvPA"
      }, "アバター／ポスター募集に応募する")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "note -apply" }, "※ 募集は締め切りました")
  ])
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "main-heading",
  id: "program"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: "企画一覧"
  })
], -1))
const _hoisted_19 = { class: "program-wrap" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "main-heading" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: "注意事項"
  })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" 本イベントへの参加にあたっては、"),
    /*#__PURE__*/_createElementVNode("a", { href: "https://vr.jmof.jp/terms" }, "VR JMoFの参加規約"),
    /*#__PURE__*/_createTextVNode("、およびそれぞれのVRプラットフォームの利用規約やガイドラインを遵守してください。 ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, " 本イベントは、プレイベントという性質上、企画開催や動画配信の方法などについて試験的な運用を行うことがあります。そのため、企画や配信が中断されたり、うまく視聴できなかったりする場合も想定されます。ご不便をおかけしますが、なにとぞご承知おきください。 "),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" 本イベントは日本語で進行します。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Note: Many of the programs will take place in the Japanese language. ")
  ])
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-logo" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "logo-link",
      href: "https://hello.vrchat.com/",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "image",
        src: _imports_9,
        alt: "VRChat"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "logo-link",
      href: "https://neos.com/",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "image",
        src: _imports_10,
        alt: "NeosVR"
      })
    ])
  ])
], -1))
const _hoisted_23 = { class: "event-link" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-main" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image",
    src: _imports_11
  }),
  /*#__PURE__*/_createTextVNode("ワールドに入場する ")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sub" }, "インスタンス一覧ページへ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogBox = _resolveComponent("DialogBox")!
  const _component_ProgramCard = _resolveComponent("ProgramCard")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createBlock(_component_TheDetailPageBody, { class: "page-prologue" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogTimetable = true))
            }, _hoisted_10),
            _createElementVNode("div", {
              class: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogMap = true))
            }, _hoisted_13)
          ]),
          _withDirectives(_createVNode(_component_DialogBox, {
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogTimetable = false))
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.dialogTimetable]
          ]),
          _withDirectives(_createVNode(_component_DialogBox, {
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogMap = false))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.dialogMap]
          ])
        ]),
        _hoisted_16,
        _hoisted_17,
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_ProgramCard, { data: _ctx.eventData }, null, 8, ["data"])
        ]),
        _hoisted_20,
        _hoisted_21,
        _hoisted_22
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_router_link, {
          class: "link",
          to: "/access/instances"
        }, {
          default: _withCtx(() => [
            _hoisted_24,
            _hoisted_25
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}